import { forwardRef } from 'react'
import { UseFormFieldProps, useFormField, FormField } from './FormField'
import { SuggestionsInputProps as RootProps } from '@/ui/SuggestionsInput'
import { SuggestionsInput as Root } from '@/ui/SuggestionsInput'
import { useController, useFormContext } from 'react-hook-form'

interface Props extends UseFormFieldProps, Omit<RootProps, 'value' | 'onChange'> {
    // UseFormFieldProps requires 'name', so we override.
    // This also allows us to extend UseFormFieldProps and
    // RootProps at the same time.
    name: string
}

export const SuggestionsInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { formFieldProps, childProps } = useFormField(props)
    const { field } = useController({ name: props.name })
    const form = useFormContext()
    const state = form.getFieldState(props.name, form.formState)

    return (
        <FormField {...formFieldProps}>
            <Root
                {...childProps}
                value={field.value}
                onChange={field.onChange}
                ref={ref}
                error={!!state.error?.message}
            />
        </FormField>
    )
})
